(function () {
  'use strict';

  // ── CONFIG — edit these ──────────────────────────────────────────
  // Where "Take me there" sends the visitor. Point this at your EU store.
  var EU_STORE_URL = 'https://eu.chaseandstatus.co.uk';

  // ISO 3166-1 alpha-2 country codes that trigger the popup.
  // UK is intentionally excluded since this is the UK store.
  var QUALIFYING_COUNTRIES = [
    'FR', // France
    'AT', // Austria
    'BE', // Belgium
    'CH', // Switzerland
    'DE', // Germany
    'ES', // Spain
    'IT', // Italy
    'NL', // Netherlands
    'PT', // Portugal
    'FI'  // Finland
  ];

  // How many days to remember a "Stay here" dismissal before asking again.
  var DISMISS_DAYS = 14;

  // Free tier, no signup, rate-limited (~1000 requests/day at time of
  // writing). For real traffic volume, swap this for a paid provider
  // (e.g. ipinfo.io with a token) — same response shape (.country_code
  // or equivalent) just update the fetch URL and the two lines marked
  // below with RESPONSE PARSING.
  var GEO_API_URL = 'https://ipapi.co/json/';
  // ──────────────────────────────────────────────────────────────────

  var COOKIE_NAME = 'cst_geo_popup_dismissed';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/;SameSite=Lax';
  }

  function init() {
    if (getCookie(COOKIE_NAME)) return; // already dismissed recently

    fetch(GEO_API_URL)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        // RESPONSE PARSING: ipapi.co returns { country_code: "FR", country_name: "France", ... }
        var countryCode = data.country_code;
        var countryName = data.country_name || countryCode;

        if (!countryCode || QUALIFYING_COUNTRIES.indexOf(countryCode) === -1) return;

        showPopup(countryName);
      })
      .catch(function () {
        // Geolocation lookup failed (rate-limited, network error, etc).
        // Fail silently — never block the page or show a broken popup.
      });
  }

  function showPopup(countryName) {
    var popup = document.getElementById('cst-geo-popup');
    if (!popup) return;

    var countryEl = popup.querySelector('[data-geo-popup-country]');
    if (countryEl) countryEl.textContent = countryName;

    var goButton = popup.querySelector('[data-geo-popup-go]');
    if (goButton) goButton.setAttribute('href', EU_STORE_URL);

    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');

    var dismissEls = popup.querySelectorAll('[data-geo-popup-dismiss]');
    dismissEls.forEach(function (el) {
      el.addEventListener('click', function (event) {
        event.preventDefault();
        dismiss();
      });
    });
  }

  function dismiss() {
    var popup = document.getElementById('cst-geo-popup');
    if (popup) {
      popup.hidden = true;
      popup.setAttribute('aria-hidden', 'true');
    }
    setCookie(COOKIE_NAME, '1', DISMISS_DAYS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
